import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { TariffWrapper } from '../../../../web/tariff/wrapper/tariff-wrapper';
import { TariffHeader } from '../../../../web/tariff/header/tariff-header';
import { TariffFeaturesPremiumPlus } from '../../../../web/tariff/features/premium-plus/tariff-features-premium-plus';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { TariffPremiumPlusPrice } from '../../../../web/tariff/premium-plus/price/tariff-premium-plus-price';

export const ModalPremiumPlusTariff: React.FC = observer(() => {
    const { premiumPlusDialogStore } = useRootStore();
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <div
            className="tariff-premium-plus-wrapper w-full rounded-[2.4rem] bg-neutral-white text-[var(--tariff-color)] lg:max-w-[42rem]"
            style={
                {
                    '--tariff-color': theme.palette.color.positive.dark,
                    '--tariff-color-darken': theme.palette.color.positive.darken,
                    '--tariff-color-light': theme.palette.color.positive.opacity.medium,
                    '--tariff-background': theme.palette.color.positive.opacity.medium,
                    '--tariff-border': 'transparent',
                } as React.CSSProperties
            }
        >
            <TariffWrapper>
                <TariffHeader name={t(`blocks.pricing.premiumPlus.name`)} />

                <TariffPremiumPlusPrice period={premiumPlusDialogStore.period} />

                <TariffFeaturesPremiumPlus />
            </TariffWrapper>
        </div>
    );
});
